import React, { useMemo, ReactNode } from 'react';
import { SpacerRow } from '../SpacerRow';
import { ICellProps, ITabProps, UnderlineTab } from './UnderlineTab';
import { UnderlineTabContainerStyled } from './UnderlineTabs.styled';
import { useHistory } from 'react-router';

interface ITab {
  tab: ITabProps;
  content: ReactNode;
  route: string;
}
export interface IUnderlineTabsWrapperProps {
  children: ITab[];
  cell?: ICellProps;
  wrap?: boolean;
}

export const UnderlineTabsWrapper = ({ children, wrap = true, cell }: IUnderlineTabsWrapperProps) => {
  const history = useHistory();

  const tabs = useMemo(() => {
    return children.map((t, i) => ({ ...t.tab, route: t.route, onClick: () => history.push(t.route) }));
  }, [children, history]);

  return (
    <>
      <UnderlineTabContainerStyled data-test-id={'underline-tab'}>
        {tabs.map((tab) => (
          <UnderlineTab
            key={tab.route}
            tab={tab}
            cell={cell}
            isActive={history.location.pathname.startsWith(tab.route)}
          />
        ))}
      </UnderlineTabContainerStyled>
      <SpacerRow />
      {tabs.map((tab, index) => (
        <React.Fragment key={tab.route}>
          {history.location.pathname.startsWith(tab.route) && children[index].content}
        </React.Fragment>
      ))}
      <SpacerRow />
      {wrap && (
        <UnderlineTabContainerStyled data-test-id={'underline-tab'}>
          {tabs.map((tab) => (
            <UnderlineTab
              key={tab.route}
              tab={tab}
              cell={cell}
              isActive={history.location.pathname.startsWith(tab.route)}
            />
          ))}
        </UnderlineTabContainerStyled>
      )}
    </>
  );
};
